import React from 'react'

const InfoCard = ({ variant, children }) => {
  return (
    <div className={`app-infocard ${variant ? `app-infocard-${variant}` : ''}`}>
      <div className='infocard-content'>
        {children}
      </div>
    </div>
  )
}

export default InfoCard
